import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoProps from './types';

const Info: React.FC<InfoProps> = ({ title, value }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h2">{title}</Typography>
      {typeof value === 'string' ? (
        <Typography variant="body1">{value}</Typography>
      ) : (
        value
      )}
    </Box>
  );
};

export default Info;
